import React from 'react'

const FacebookIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="22"
    fill="none"
    viewBox="0 0 12 22"
    {...props}
  >
    <path
      fill="#000"
      d="M3.724 12.363v9.148h4.091v-9.148h3.051l.58-3.785h-3.63V6.123c0-1.036.507-2.045 2.133-2.045h1.65V.856S10.102.6 8.67.6C5.68.6 3.724 2.412 3.724 5.694v2.884H.4v3.785h3.324z"
    ></path>
  </svg>
)

export default FacebookIcon
